<template>
  <div class="rich-text-editor">
    <div style="border: 1px solid #ccc;">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editorRef"
        :defaultConfig="toolbarConfig"
      />
      <Editor
        style="height: 300px; overflow-y: hidden;"
        v-model="html"
        :defaultConfig="editorConfig"
        @onCreated="handleCreated"
      />
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount, watch } from 'vue';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import '@wangeditor/editor/dist/css/style.css';

export default {
  name: 'RichTextEditor',
  components: {
    Editor,
    Toolbar
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // 编辑器实例，必须用 ref
    const editorRef = ref(null);
    // 内容 HTML
    const html = ref(props.modelValue);
    
    // 获取API基础地址
    const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || '/api';
    
    // 编辑器配置
    const editorConfig = {
      placeholder: '请输入内容...',
      // 图片上传配置
      MENU_CONF: {
        uploadImage: {
          // 自定义上传 — 走素材上传接口但不入库
          customUpload(file, insertFn) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('save_to_db', '0'); // 不入素材库

            const token = localStorage.getItem('token') || '';

            // 异步导入 axios 并发送请求
            import('axios').then(({ default: axios }) => {
              axios({
                url: `${apiBaseUrl}/manage/media/upload`,
                method: 'post',
                data: formData,
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': `Bearer ${token}`,
                },
                timeout: 15000,
              }).then(response => {
                const res = response.data;

                if (res.errno === 0 && res.data && res.data.length > 0) {
                  let imgUrl = res.data[0].url;

                  // 确保返回的是完整的绝对路径
                  if (imgUrl && !imgUrl.startsWith('http://') && !imgUrl.startsWith('https://')) {
                    const domainMatch = apiBaseUrl.match(/^(https?:\/\/[^\/]+)/);
                    const baseDomain = domainMatch ? domainMatch[1] : window.location.origin;
                    imgUrl = `${baseDomain}${imgUrl}`;
                  }

                  console.log('富文本图片上传成功，插入URL:', imgUrl);
                  // 插入带 style="width:100%" 的图片
                  editorRef.value.dangerouslyInsertHtml('<img src="' + imgUrl + '" style="width:100%" />');

                  import('element-plus').then(({ ElMessage }) => {
                    ElMessage.success('图片上传成功');
                  });
                } else {
                  import('element-plus').then(({ ElMessage }) => {
                    ElMessage.error('图片上传失败: ' + (res.message || '未知错误'));
                  });
                }
              }).catch(error => {
                import('element-plus').then(({ ElMessage }) => {
                  ElMessage.error('图片上传失败: ' + error.message);
                });
              });
            });
          }
        }
      }
    };
    
    // 工具栏配置
    const toolbarConfig = {
      // 工具栏选项
      excludeKeys: ['uploadVideo', 'insertVideo'] // 排除视频上传功能
    };
    
    // 编辑器创建完成时的回调
    const handleCreated = (editor) => {
      editorRef.value = editor; // 记录 editor 实例
    };
    
    // 监听内容变化，同步到父组件
    watch(html, (newValue) => {
      emit('update:modelValue', newValue);
    });
    
    // 监听父组件传值变化，更新编辑器内容
    watch(() => props.modelValue, (newValue) => {
      if (editorRef.value && html.value !== newValue) {
        html.value = newValue;
      }
    });
    
    // 组件销毁时，销毁编辑器
    onBeforeUnmount(() => {
      if (editorRef.value) {
        editorRef.value.destroy();
      }
    });
    
    return {
      editorRef,
      html,
      editorConfig,
      toolbarConfig,
      handleCreated
    };
  }
}
</script>

<style scoped>
.rich-text-editor {
  width: 100%;
}
.rich-text-editor img {
  width: 100% !important;
}
</style>